const TARTAR_COOKIE_NAME = 'tarteaucitron';

export function getSavedConsent() {
  try {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === TARTAR_COOKIE_NAME) {
        return value ? JSON.parse(decodeURIComponent(value)) : null;
      }
    }
    return null;
  } catch (e) {
    return null;
  }
}

export function saveConsent(value) {
  try {
    if (typeof window.tarteaucitron !== 'undefined') {
      window.tarteaucitron.userInterface.savePreferences();
    }
  } catch (e) {
    // ignore
  }
}

export function applyConsentToGtag(consented) {
  const granted = consented ? 'granted' : 'denied';
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  gtag('consent', 'update', {
    analytics_storage: granted,
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });
}

export function hasConsentedAnalytics() {
  try {
    if (typeof window.tarteaucitron !== 'undefined') {
      const status = window.tarteaucitron.status;
      if (status === 'accept') {
        return true;
      }
      if (status === 'deny') {
        return false;
      }
    }
    const saved = getSavedConsent();
    if (saved && saved.applications) {
      const gcmanalytics = saved.applications.find(app => app.includes('gcmanalyticsstorage') || app.includes('analytics'));
      if (gcmanalytics) return true;
    }
    return false;
  } catch (e) {
    return false;
  }
}

export function setAnalyticsConsent(consented) {
  try {
    if (typeof window.tarteaucitron !== 'undefined') {
      if (consented) {
        window.tarteaucitron.userInterface.respondAll(true);
      } else {
        window.tarteaucitron.userInterface.respondAll(false);
      }
    }
    applyConsentToGtag(!!consented);
  } catch (e) {
    applyConsentToGtag(false);
  }
}

export function resetConsent() {
  try {
    if (typeof window.tarteaucitron !== 'undefined') {
      window.tarteaucitron.userInterface.clearServices();
      window.tarteaucitron.userInterface.respondAll(false);
    }
  } catch (e) {}
  applyConsentToGtag(false);
}
